import { render, staticRenderFns } from "./VSlideGrupo.vue?vue&type=template&id=e4be85b6&scoped=true&"
import script from "./VSlideGrupo.vue?vue&type=script&async=true&lang=js&"
export * from "./VSlideGrupo.vue?vue&type=script&async=true&lang=js&"
import style0 from "./VSlideGrupo.vue?vue&type=style&index=0&id=e4be85b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4be85b6",
  null
  
)

export default component.exports